<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-tennis`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 24c0-12.15-9.85-22-22-22S2 11.85 2 24s9.85 22 22 22 22-9.85 22-22zm-4.045 1.103h.012C41.397 34.53 33.57 42 24 42l.224-.002c1.348-8.959 8.64-15.971 17.731-16.895zM26.785 6.214l-.04.298c-1.546 10.542-9.946 18.858-20.53 20.274 1.146 7.382 6.78 13.28 14.024 14.82 1.545-10.923 10.445-19.481 21.528-20.504-1.238-7.657-7.308-13.696-14.981-14.888zm-4.099-.167l.084-.004c-1.314 8.61-8.118 15.413-16.729 16.726.604-8.932 7.724-16.078 16.645-16.722z"/></svg>
</template>
<script>

export default {
  name: 'IconTennis',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
